import type { FaireProductEntity } from "../../entity_types/product";

export const p_86h4gvqb99: FaireProductEntity = {
  token: "p_86h4gvqb99",
  type: "product",
  name: "Rainbow Cross Stitch Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bace8b47c207e13554230feba5fb8f0e4d6e5d80d6a9d72fac38f1655f2de72a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de7c8f690c1c40c7989836de53efbb70902ad9803c280b321a3f67fc9fb0e5af.jpeg",
    "https://cdn.faire.com/fastly/48f6a4174c5c6ef4a375bd40c437c59bf768568c3c2675abfaabd2034abc072b.jpeg",
    "https://cdn.faire.com/fastly/6710d031014c4d6f23b935d932c1cd0629ba029fc8d642692f8add8392d02a3f.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:26.132Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
